import { CommonService } from './../services/common.service';
import { VrService } from './../services/vr.service';
import { Component, ViewChild } from '@angular/core';
import { Platform, NavController, Events } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { AppVersion } from '@ionic-native/app-version';
import { AppAvailability } from '@ionic-native/app-availability';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { TabsPage } from '../pages/tabs/tabs';
import { AuthService } from '../providers/auth.service';
import { SigninPage } from '../pages/signin/signin';
import { StorageService } from '../providers/storage.service';
import { AlertService } from '../providers/alert.service';
import { LotteryModel } from '../models/lottery.model';
import { GroupByPipe } from 'ng-pipes';
import { BettingOrderPage } from '../pages/bettingorder/bettingorder';
import { BettingParamService } from '../services/betting.param.service';
import { RechargePage } from '../pages/recharge/recharge';
import { WithdrawPage } from '../pages/withdraw/withdraw';
import { TransferPage } from '../pages/transfer/transfer';
import { DepositRecordPage } from '../pages/deposit-record/deposit-record';
import { TransferRecordPage } from '../pages/transfer-record/transfer-record';
import { WithdrawRecordPage } from '../pages/withdraw-record/withdraw-record';
import { NormalReport } from '../pages/normalreport/normalreport';
import { ChaseReport } from '../pages/chasereport/chasereport';
import { AccountChange } from '../pages/accountchange/accountchange';
import { UserBankList } from '../pages/userbanks/userbanklist';
import { ScancodePage } from '../pages/scancode/scancode';
import { AppConfig } from './app.config';
import { SysconfigService } from '../services/sysconfig.service';
import { ToastService } from '../providers/toast.service';
import { UserModel, AppInfo } from '../models/user.model'
import { HttpService } from '../providers/http.service';
import { SigninService } from '../services/signin.service';
import * as $ from 'jquery';
import { WechatBindPage } from '../pages/wechat/wechatbind';
import { WechatUnBindPage } from '../pages/wechat/wechatunbind';
import { WechatRegistPage } from '../pages/wechat/wechatregist';
import { RegistPage } from '../pages/regist/regist';
import { WechatPage } from '../pages/wechat/wechat';
import { MaintainPage } from '../pages/maintain/maintain';
import { DomainsPage } from '../pages/domains/domains';
import { PgPage } from '../pages/home/pg/pg';
import { LinkCollectionPage } from '../pages/link-collection/link-collection';
import { NewMaintainPage } from '../pages/new-maintain/maintain';
@Component({
	templateUrl: 'app.html',
	providers: [
		GroupByPipe,
		SysconfigService,
		AppVersion,
		AppAvailability,
		VrService,
		SigninService
	]
})
export class LegendApp {
	rootPage;
	lotterytabs = [];
	menutabs = [
		{
			typeName: "彩票游戏",
			data: [],
			isDisplay: false,
			type: "03",
			icon: "enight"
		},
		{
			typeName: "个人中心",
			data: [
				{ LotteryName: "充值", component: RechargePage },
				{ LotteryName: "提现", component: WithdrawPage },
				{ LotteryName: "转账", component: TransferPage },
				{ LotteryName: "银行卡/钱包管理", component: UserBankList }],
			isDisplay: false,
			type: "01",
			icon: "md-people"
		},
		{
			typeName: "报表管理",
			data: [
				{ LotteryName: "充值记录", component: DepositRecordPage },
				{ LotteryName: "提现记录", component: WithdrawRecordPage },
				{ LotteryName: "转账记录", component: TransferRecordPage },
				{ LotteryName: "游戏记录", component: NormalReport },
				{ LotteryName: "追号记录", component: ChaseReport },
				{ LotteryName: "帐变记录", component: AccountChange }],
			isDisplay: false,
			type: "01",
			icon: "jilu"
		}
	];
	firstFlag: boolean = false;
	version: string = '';
	maintainLoop; //维护轮训定时器
	public appid: string = "";
	public state: string = "";
	public code: string = "";
	public _redirect_uri: string;
	public codeState: { code: string; state: string; }
	public unionidlink: { unionid: string; link: string; }
	@ViewChild('nav') nav: NavController;
	constructor(
		private platform: Platform,
		private appVersion: AppVersion,
		private iab: InAppBrowser,
		private sysconfig: SysconfigService,
		private auth: AuthService,
		private events: Events,
		private groupBy: GroupByPipe,
		private storage: StorageService,
		private config: AppConfig,
		private alert: AlertService,
		private toast: ToastService,
		statusBar: StatusBar,
		splashScreen: SplashScreen,
		private vrService: VrService,
		private common: CommonService
	) {
		platform.ready().then(() => {
			// 浏览器/WAP 使用同源代理，Cordova App 使用完整 SignalR 地址。
			AppConfig.isWap = !platform.is('cordova');
			if (location.href.includes("thirdCode")) {
				this.nav.setRoot(PgPage);
				return;
			}

			if (location.href.includes("urls-collect")) {
				this.nav.setRoot(LinkCollectionPage);
				return;
			}

			if (location.href.includes("maintenance")) {
				this.nav.setRoot(NewMaintainPage);
				return;
			}

			statusBar.styleDefault();
			splashScreen.hide();
			this.maintainLoop = setInterval(() => {
				this.getMaintainSettings();
			}, 5000)
			// mongo 判断微信浏览器并获取授权登陆
			let isWeixinBrowser = (/micromessenger/i).test(navigator.userAgent);
			if (isWeixinBrowser) {
				let scancode = this.common.getParam("scancode") || this.storage.readString("scancode");;		    //允许PC端登录
				let registkey = this.common.getParam("key") || this.storage.readString("registKey");				//微信注册授权登录
				let wxbinding = this.common.getParam("wxbinding") || this.storage.readString("wxbinding");		    //绑定微信
				let unwxbinding = this.common.getParam("unwxbinding") || this.storage.readString("unwxbinding");	//解绑微信
				if (wxbinding) {
					this.storage.writeString("wxbinding", wxbinding);
					this.nav.setRoot(WechatBindPage);
				} else if (unwxbinding) {
					this.storage.writeString("unwxbinding", unwxbinding);
					this.nav.setRoot(WechatUnBindPage);
				} else if (scancode) {
					this.storage.writeString("scancode", scancode);
					this.nav.setRoot(ScancodePage);
				} else if (registkey) {
					this.storage.writeString("registKey", registkey);
					this.nav.setRoot(WechatRegistPage);
				} else {
					this.nav.setRoot(WechatPage);
				}
			} else {
				let key = location.search;
				if (key && key.indexOf('Key') > -1) {
					this.nav.setRoot(RegistPage, { key: key.split('=')[1] });
					return;
				}
				// 切换测速页
				if (auth.loggedIn()) {
					this.rootPage = TabsPage;
				} else {
					if (this.platform.url().startsWith("http")) {
						if (location.href.includes("login")) {
							this.rootPage = SigninPage;
						} else {
							// this.rootPage = DomainsPage;
							this.rootPage = SigninPage;
						}
					} else {
						this.rootPage = SigninPage;
					}
				}
				events.subscribe('auth:unauthorized', () => {
					this.nav.setRoot(SigninPage);
				});
			}
			events.subscribe("legend.notifications.received", notification => {
				switch (notification.Type) {
					case "Kickout"://您已经被管理通知下线
						this.alert.showAlert("您已经被管理通知下线");
						this.exit();
						break;
					case "ResetLoginPwd"://后台修改登录密码
						this.alert.showConfirms('登录密码已被重置', () => {
							this.exit();
						});
						break;
					case "UserCapital"://用户信息
					case "UserExpand":
					case "UserInfo":
						let user = this.storage.read<UserModel>("User");
						$.extend(user, notification.Data);
						this.storage.write("User", user);
						AppConfig.User = user;
						break;
					case "UserMessage":
						this.onUserMessage(notification.Data);
						break;
					case "UserNotice":
						this.onUserNotice(notification.Data);
						break;
					case "Announcement":
					case "Release"://公告推送
						this.alert.alert({
							title: notification.Data.Title,
							message: notification.Data.Summary,
							buttons: [
								{
									text: "确认"
								}
							]
						});

						break;
					case "OtherPlaceLogin"://被迫下线
						// this.alert.showAlert("该帐户已在其它地方登录，您将退出。如果不是本人操作，您的密码可能已泄露，请尽快修改密码。");
						let a = this.alert.alert({
							subTitle: "该帐户已在其它地方登录，您将退出。如果不是本人操作，您的密码可能已泄露，请尽快修改密码。",
							buttons: [
								{
									text: "确认",
									handler: () => {
										let navTransition = a.dismiss();
										navTransition.then(() => {
											this.exit();
										});
										return false;
									}
								}
							]
						});
						break;
					default:
						this.events.publish(notification.Type, notification.Data);
				}
			});
			this.config.NavCtrl = this.nav;
			let hiddenPropName = this.getHiddenProp();
			if (hiddenPropName != null) {
				let evtname = hiddenPropName.replace(/[H|h]idden/, '') + 'visibilitychange';
				document.addEventListener(evtname, (e) => {
					if (this.isHidden()) {
						this.events.publish("documentHidden");
					} else {
						this.events.publish("documentShow");
					}
				});
			}
			this.versionUpdate();
			this.sysconfig.getSysconfig().then(sc => {
				this.storage.write("sysconfig", sc);
			});
		});
	}

	// mango 获取url 参数的方法
	// getParam(paramName) {
	//   var paramValue = "", isFound = !1;
	//   if (window.location.search.indexOf("?") == 0 && window.location.search.indexOf("=") > 1) {
	//     var arrSource = decodeURI(window.location.search).substring(1, window.location.search.length).split("&"), i = 0;
	//     while (i < arrSource.length && !isFound)
	//       arrSource[i].indexOf("=") > 0 && arrSource[i].split("=")[0].toLowerCase() == paramName.toLowerCase() && (paramValue = arrSource[i].split("=")[1], isFound = !0), i++
	//   }
	//   return paramValue == "" && (paramValue = null), paramValue
	// }
	// //mango 获取appid -- 判断code 是否为空，如果是就跳转授权点击登陆按钮页面，拿到用户授权code后就可以请求登陆
	// getAppids() {

	// }
	// mango 获取到code时，跳转登陆时判断用户是否有绑定用户帐号，如果绑定直接跳转到首页。
	// login(codeState) {
	// window.alert("微信浏览器登录：" + isWeixinBrowser);
	//   let scancode = this.common.getParam("scancode") || this.storage.readString("scancode");;		    //允许PC端登录
	//   let registkey = this.common.getParam("key") || this.storage.readString("registKey");				//微信注册授权登录
	//   let wxbinding = this.common.getParam("wxbinding") || this.storage.readString("wxbinding");		    //绑定微信
	//   let unwxbinding = this.common.getParam("unwxbinding") || this.storage.readString("unwxbinding");	//解绑微信
	//   if (wxbinding) {
	//     this.storage.writeString("wxbinding", wxbinding);
	//     this.nav.setRoot(WechatBindPage);
	//   } else if (unwxbinding) {
	//     this.storage.writeString("unwxbinding", unwxbinding);
	//     this.nav.setRoot(WechatUnBindPage);
	//   } else if (scancode) {
	//     this.storage.writeString("scancode", scancode);
	//     this.nav.setRoot(ScancodePage);
	//   } else if (registkey) {
	//     this.storage.writeString("registKey", registkey);
	//     this.nav.setRoot(WechatRegistPage);
	//   } else {
	//     this.nav.setRoot(WechatPage);
	//   }
	// }
	getHiddenProp() {
		var prefixes = ['webkit', 'moz', 'ms', 'o'];
		// if 'hidden' is natively supported just return it
		if ('hidden' in document) return 'hidden';
		// otherwise loop over all the known prefixes until we find one
		for (var i = 0; i < prefixes.length; i++) {
			if ((prefixes[i] + 'Hidden') in document)
				return prefixes[i] + 'Hidden';
		}
		// otherwise it's not supported
		return null;
	}
	isHidden() {
		var prop = this.getHiddenProp();
		if (!prop) return false;
		return document[prop];
	}

	//消息提醒
	//TQQ 2017-02-21
	onUserMessage(msg) {
		let title = "", content = "";
		if (msg.TypeCode == '01') {
			title = '上级发来的消息';
			content = msg.Contect;
		} else if (msg.TypeCode == '02') {
			title = '下级发来的消息';
			content = msg.Contect + '-' + msg.sendUserName;
		} else {
			title = '系统发来的消息';
			content = msg.Contect;
		}
		this.toast.showToast(content, "top");
	}
	//通知消息
	//TQQ 2017-02-21
	onUserNotice(notice) {
		let content = notice.Contect;
		this.toast.showToast(content, "top");
	}

	//打开监听
	//TQQ 2017-02-08
	menuOpened() {
		this.lotterytabs = [];
		let typetabs = [];
		let tabs = this.storage.read<LotteryModel[]>("lotterys");
		if (tabs == null) {
			this.nav.push(SigninPage);
			return;
		}
		let tt = this.groupBy.transform(tabs, "LotteryType");
		for (var i in tt) {
			let childData = [];
			tt[i].forEach(s => {
				childData.push({ LotteryName: s.LotteryName, LotteryCode: s.LotteryCode });
			});
			this.lotterytabs.push({ typeName: tt[i][0]["LotteryTypeName"], data: childData, isDisplay: false, type: "02" });

			typetabs.push({ LotteryName: tt[i][0]["LotteryTypeName"], data: childData, isDisplay: false, type: "03" });
		}
		if (AppConfig.VrIsOpen) {
			let game = this.menutabs.find(s => s.typeName == '彩票游戏');
			if (game) {
				let vr = {
					LotteryName: 'VR彩票', data: [
						{ LotteryName: 'VR金星1.5分彩', LotteryCode: '1', type: 'vr' },
						{ LotteryName: 'VR火星5分彩', LotteryCode: '12', type: 'vr' },
						{ LotteryName: 'VR3分彩', LotteryCode: '11', type: 'vr' },
						{ LotteryName: 'VR赛车', LotteryCode: '2', type: 'vr' },
						{ LotteryName: 'VR快艇', LotteryCode: '13', type: 'vr' },
						{ LotteryName: 'VR彩票百家乐', LotteryCode: '15', type: 'vr' },
						{ LotteryName: 'VR六合彩', LotteryCode: '16', type: 'vr' }
					], isDisplay: false, type: '03'
				};
				typetabs.splice(0, 0, vr);
			}
		}
		this.menutabs[0].data = typetabs;
	}

	// menu抽屉关闭监听事件
	menuClosed() {
		this.events.publish('menu:closed', 'closed', new Date());
	}

	//返回首页
	//TQQ 2017-02-08
	goHome() {
		clearInterval(this.config.setIntervalid)
		this.nav.setRoot(TabsPage);
	}

	//是否显示一级级彩票列表
	//TQQ 2017-02-08
	disChild(lotteryType) {
		this.menutabs.forEach(s => {
			if (s.typeName != lotteryType.typeName && s.isDisplay) {
				s.isDisplay = false;
			}
		});
		lotteryType.isDisplay = !lotteryType.isDisplay;
		if (lotteryType.type == '03') {
			this.disChildLottery(lotteryType.data[0], lotteryType.data);
		}
	}

	//是否显示二级子页
	disChildLottery(lotteryType, types) {
		this.firstFlag = true;
		types.forEach(s => {
			if (s.LotteryName != lotteryType.LotteryName && s.isDisplay) {
				s.isDisplay = false;
			}
		});
		lotteryType.isDisplay = !lotteryType.isDisplay;
	}

	//跳转到一级子页  //TQQ 2017-02-08
	openLotteryPage(data, type) {
		// clearInterval(this.config.setIntervalid);
		if (type == "02") {
			BettingParamService.applyPlayModeBeforeNavigate(data.LotteryCode, this.storage);
			let pages = [
				{ page: TabsPage },
				{
					page: BettingOrderPage,
					params: { lotteryCode: data.LotteryCode }
				}
			];
			this.nav.setPages(pages);
			// setTimeout(() => {
			//     this.common.sideMenu.next(true);
			// }, 500);
		} else if (type == "01") {
			this.firstFlag = !this.firstFlag;
			this.nav.push(data.component);
		}
	}

	// 维护
	getMaintainSettings() {
		this.sysconfig.getMaintainSettings().then(res => {
			if (res.IsOpen) {
				this.nav.push(MaintainPage, { maintainInfo: res })
				clearInterval(this.maintainLoop);

			}
		}).catch(err => {
		})
	}

	//跳转vr
	//TQQ 2018-01-26
	openvr(channelId = 0) {
		this.vrService.openVr(channelId).then(v => {
			if (v) {
				if (v.Result) {
					this.alert.showConfirm('确定要跳转VR彩票吗？', () => {
						this.config.openUrl(v.Parameter);
					});
				} else {
					this.alert.showAlert(v.Error);
				}
			}
		});
	}

	//退出登录
	//TQQ 2017-02-08
	exit() {
		this.storage.remove("User");
		this.storage.remove("token");
		this.storage.remove("lotterys");
		this.storage.clear();
		this.nav.setRoot(SigninPage);
	}

	//版本更新提示
	versionUpdate() {
		if (this.platform.is('mobileweb') || (!this.platform.is('ios') && !this.platform.is('android'))) {
			return false;
		}
		this.appVersion.getVersionNumber().then((version) => {
			this.sysconfig.GetPhoneSettings(null).then(s => {
				if (!s.IsOpen) {
					return false;
				}
				let settingVersion = s.IosVersion;
				let url = s.IosUrl;
				let plat = 'Ios';
				if (this.platform.is('android')) {
					settingVersion = s.AndroidVersion;
					url = s.AndroidUrl;
					plat = 'Android';
				}
				settingVersion = settingVersion.split(".").join("");
				version = version.split(".").join("");
				// alert(parseFloat(version) + "----" + parseFloat(settingVersion));
				// alert(parseFloat(version) < parseFloat(settingVersion));
				if (parseFloat(version) < parseFloat(settingVersion)) {
					plat == 'Android' ? this.alert.showConfirm('检测到您的app不是最新版本，请下载最新版本' + settingVersion, () => {
						this.iab.create(url, '_system');
						this.platform.exitApp();
					}, '版本更新', cancel => {
						this.platform.exitApp();
					}, false) :
						this.alert.alert({
							title: "版本更新",
							subTitle: "检测到您的app不是最新版本，请下载最新版本" + settingVersion,
							buttons: [
								{
									text: "确认",
									handler: () => {
										this.iab.create(url, '_system');
										return false;
									}
								}
							],
							enableBackdropDismiss: false
						});
				}
			});
		});
	}
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts